import { render, staticRenderFns } from "./DocumentSection.vue?vue&type=template&id=39f7d6f1"
import script from "./DocumentSection.vue?vue&type=script&lang=js"
export * from "./DocumentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports